import React, { Suspense } from "react";
import styled from "styled-components";

const QuienesSomosContainer = styled.section`
  background-color: #f5faff;
  color: #1d3557;
  padding: 70px 20px;
  text-align: center;
  font-family: "Merriweather", serif;
`;

const Title = styled.h2`
  font-size: 3rem;
  margin-bottom: 30px;
  color: #1d3557;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 25px;
`;

const Description = styled.p`
  font-size: 1.2rem;
  max-width: 850px;
  line-height: 1.8;
  color: #2d2d2d;
`;

const ImageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const MediationStats = styled.div`
  background-color: #eaf4ff;
  padding: 30px;
  border-radius: 10px;
  margin-top: 40px;
  text-align: left;
  max-width: 850px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
`;

const MediationTitle = styled.h3`
  font-size: 2rem;
  text-align: center;
  margin-bottom: 20px;
  color: #1d3557;
`;

const MediationText = styled.p`
  font-size: 1.2rem;
  line-height: 1.8;
  color: #333;
`;

const CallToAction = styled.div`
  background-color: #dff0ff;
  padding: 25px;
  margin-top: 40px;
  border-radius: 10px;
  max-width: 850px;
  text-align: center;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
`;

const CTAHeader = styled.h3`
  font-size: 1.8rem;
  margin-bottom: 20px;
  color: #1d3557;
`;

const CTAButton = styled.button`
  background-color: #1d3557;
  color: #ffffff;
  padding: 12px 24px;
  font-size: 1.1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  transition: 0.3s;

  &:hover {
    background-color: #457b9d;
  }
`;


const QuienesSomos = () => {
  return (
    
    <QuienesSomosContainer>
    
      <Title>¿Quiénes Somos?</Title>
      <ContentWrapper>
        {/* Mediation Statistics Section */}
        <Description>
        <MediationText>
        En <strong>Soma Mediación</strong>, creemos en el poder del diálogo y la resolución pacífica de conflictos. 
        Nuestro equipo está altamente capacitado para ayudar a individuos, familias y empresas a encontrar soluciones efectivas.
        <br/>
        </MediationText>

    
          <br/>
   
        <ImageContainer>
          <Suspense fallback={<div>Cargando imagen....</div>}>
            <img
              src={`${process.env.PUBLIC_URL}/images/Team.webp`}
              alt="Mediación y Resolución de Conflictos"
              loading="lazy"
              style={{ width: "100%", maxWidth: "600px", borderRadius: "10px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)" }}
            />
          </Suspense>
        </ImageContainer>
        <br/>
        <MediationText>
            Cada año, miles de personas y empresas recurren a la mediación como una alternativa eficaz a los procesos judiciales largos y costosos. 
            En los últimos años, hemos facilitado más de <strong>100</strong> mediaciones con una tasa de éxito superior al 85%. 
            Nuestra experiencia nos permite abordar casos complejos con profesionalismo e integridad.
          </MediationText>
        </Description>

        {/* Call to Action Section */}
        <CallToAction>
          <CTAHeader>¿Por qué elegirnos?</CTAHeader>
          <MediationText>
            Evita litigios innecesarios y encuentra soluciones rápidas y efectivas con nuestro equipo especializado en mediación. 
            Si estás enfrentando un conflicto personal, familiar o empresarial, ¡contáctanos hoy mismo!
          </MediationText>
          <CTAButton onClick={() => window.location.href = "./Contact"}>Contáctanos</CTAButton>
        </CallToAction>

       
      </ContentWrapper>
    </QuienesSomosContainer>
  );
};

export default QuienesSomos;
